<h1 mat-dialog-title>Inserisci un nome per la watchlist</h1>
<div mat-dialog-content>
    <mat-form-field appearance="fill">
        <mat-label>Nome</mat-label>
        <input matInput [formControl]="watchlistName">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="confirm()">Conferma</button>
    <button mat-button (click)="cancel()">Annulla</button>
</div>